import './Editor.css'
import {
  CommonEditorProps,
  EditorProps,
  useEditorCore,
  EditorToolbar,
} from './EditorCore'

export type { CommonEditorProps } from './EditorCore'

export function Editor(props: EditorProps & CommonEditorProps) {
  const {
    label,
    optional,
    className,
    borderless,
    disableToolbar,
    additionalToolbarButtons,
  } = props

  const { uniqueId } = useEditorCore(props)

  return (
    <div className="mt-2">
      {label && (
        <label className="text-base font-medium text-gray-800 select-none mb-1">
          {label}
          {optional && (
            <span className={'text-sm italic font-normal'}> - optional</span>
          )}{' '}
        </label>
      )}
      <div className={borderless ? 'borderless-editor' : ''}>
        <div className={className} id={`editor-${uniqueId}`}></div>
        <div style={{ display: disableToolbar ? 'none' : 'block' }}>
          <EditorToolbar
            uniqueId={uniqueId}
            disableToolbar={disableToolbar}
            additionalToolbarButtons={additionalToolbarButtons}
          />
        </div>
      </div>
    </div>
  )
}
